// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"224":"9d2166ad","643":"7bea4911","966":"270b2d6d"}[chunkId] + ".js";
};